<template>
    <div>
        <!-- Filter Start -->
        <div class="innerBox filter">
            <div class="d-flex flex-row justify-content-between">
                <div>
                    <h2 class="page-title">Plan Alokasi Muat</h2>
                </div>
                <div class="d-flex flex-row justify-content-end">
                    <div class="mr-3">
                        <Multiselect
                            :options="regions"
                            placeholder="All Region"
                            v-model="filter.region"
                            class="tms-multiselect"
                        />
                    </div>
                    <div class="mr-3">
                        <Multiselect
                            :options="ekspedisi.map((x) => x.id)"
                            :custom-label="
                                (opt) => ekspedisi.find((x) => x.id == opt).kode
                            "
                            placeholder="All Ekspedisi"
                            v-model="filter.ekspedisi"
                            class="tms-multiselect"
                        />
                    </div>
                    <div class="mr-3">
                        <div class="input-group">
                            <flat-pickr
                                :config="rangePickr"
                                placeholder="Select Date"
                                v-model="selected.date"
                            ></flat-pickr>
                            <div class="input-group-append">
                                <span
                                    class="input-group-text bg-white border-left-0"
                                    style="
                                        border-top-right-radius: 5px;
                                        border-bottom-right-radius: 5px;
                                        border: 0;
                                        box-shadow: 0 0 6px #0000000f;
                                        background-color: #ededed !important;
                                    "
                                >
                                    <i
                                        class="fas fa-calendar"
                                        style="color: black"
                                    ></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="mr-3">
                        <button
                            class="btn"
                            type="button"
                            style="
                                background-color: #f36f21;
                                color: white;
                                width: 100%;
                                font-weight: bold;
                                margin: 0;
                            "
                            @click="modal.upload = true"
                        >
                            Upload File
                        </button>
                    </div>
                    <div class="mr-3">
                        <router-link
                            to="/dashboard/create-alokasi"
                            style="color: white; text-decoration: none"
                        >
                            <button
                                class="btn"
                                type="button"
                                style="
                                    background-color: #f36f21;
                                    color: white;
                                    width: 100%;
                                    font-weight: bold;
                                    margin: 0;
                                "
                            >
                                Create Plant
                            </button>
                        </router-link>
                    </div>
                    <a
                        href=""
                        class="btn"
                        style="margin-right: -1rem !important; padding: 0"
                    >
                        <img
                            src="@/assets/img/notification.svg"
                            alt=""
                            style="display: none"
                        />
                    </a>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Table Start -->
        <div class="row">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox mt-4">
                    <label
                        style="font-size: 20px; color: #00000; font-weight: 600"
                    >
                        Plant List
                    </label>
                    <table class="table tms-table">
                        <thead>
                            <tr>
                                <th style="width: 1%">No.</th>
                                <th style="width: 10%">Tanggal</th>
                                <th style="width: 20%">Ekspedisi</th>
                                <th style="width: 30%">Plant Tujuan</th>
                                <th style="width: 7%">Total Unit</th>
                                <th style="width: 0%"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, index) in allocationData">
                                <tr :key="index">
                                    <td>{{ index + 1 }}.</td>
                                    <td>{{ item.alokasi_date }}</td>
                                    <td>{{ item.kode_ekspedisi }}</td>
                                    <td>{{ getPlantNames(item.details) }}</td>
                                    <td>{{ getTotalQty(item.details) }}</td>
                                    <td>
                                        <div
                                            class="d-flex justify-content-around"
                                            style="width: 18.75rem"
                                        >
                                            <button
                                                class="btn btn-secondary"
                                                style="
                                                    background-color: #f7f7f7;
                                                    color: #969696;
                                                    border: none;
                                                "
                                                @click="getDetail(index)"
                                            >
                                                <i class="fal fa-list"></i>
                                                See Details
                                            </button>

                                            <router-link
                                                :to="{
                                                    name: 'EditAlokasi',
                                                    params: { id: item.id }, // Assuming item.id is the identifier of the data being edited
                                                }"
                                                style="
                                                    color: white;
                                                    text-decoration: none;
                                                "
                                            >
                                                <button
                                                    class="tms-button-circular"
                                                    type="button"
                                                >
                                                    <i class="far fa-pen"></i>
                                                </button>
                                            </router-link>

                                            <button
                                                class="tms-button-circular"
                                                @click="
                                                    confirmDelete(
                                                        item.alokasi_date
                                                    )
                                                "
                                            >
                                                <i class="far fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                <tr
                                    v-if="expandedRows[index]"
                                    :key="'details-' + index"
                                >
                                    <td colspan="5">
                                        <table
                                            class="inner-table table tms-table"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Region</th>
                                                    <th>Plant</th>
                                                    <th>Kode Ekspedisi</th>
                                                    <th>Ekspedisi</th>
                                                    <th>Qty</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(
                                                        detail, detailIndex
                                                    ) in item.details"
                                                    :key="
                                                        'detail-' + detailIndex
                                                    "
                                                >
                                                    <td>{{ detail.region }}</td>
                                                    <td>
                                                        {{ detail.plant_name }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            detail.kode_ekspedisi
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{ detail.ekspedisi }}
                                                    </td>
                                                    <td>{{ detail.qty }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- Table End -->

        <!-- Chart Start -->
        <div class="row">
            <!-- Total Unit by Ekspedisi Start  -->
            <div class="col-lg-6 col-md-6">
                <div class="innerBox mt-4">
                    <h5 class="elegant--sub-title">Total Unit by Ekspedisi</h5>
                    <ekspedisi-chart :data="ekspedisiData"> </ekspedisi-chart>
                </div>
            </div>
            <!-- Total Unit by Ekspedisi End -->
            <!-- Total Unit by Plant Start  -->
            <div class="col-lg-6 col-md-6">
                <div class="innerBox mt-4">
                    <h5 class="elegant--sub-title">Total Unit by Plant</h5>
                    <donut-chart :data="unitData"> </donut-chart>
                </div>
            </div>
            <!-- Total Unit by Plant End -->
        </div>
        <!-- Chart End -->

        <!-- Modal Start -->
        <view-detail-modal
            v-if="modal.viewPlan"
            :data="modal.viewDetailDataPlan"
            @closeModal="modal.viewPlan = false"
        />

        <AlokasiUpload
            v-if="modal.upload"
            @closeModal="modal.upload = false"
            @onFinish="getData()"
        />
        <!-- Modal End -->
    </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import Multiselect from "vue-multiselect";
import axios from "axios";
import Swal from "sweetalert2";
import "flatpickr/dist/flatpickr.css";
import DonutChart from "./children/DonutChart.vue";
import EkspedisiChart from "./children/EkspedisiChart.vue";
import ViewDetailModal from "./children/ViewDetailModal.vue";
import AlokasiUpload from "./children/PlanAlokasiMuatUpload.vue";

export default {
    metaInfo: {
        title: "Plan Alokasi Muat",
    },
    data() {
        let startDate = moment().startOf("month").format("YYYY-MM-DD");
        let currentDate = moment().format("YYYY-MM-DD");
        let user = this.$store.getters.currentUser;

        return {
            unitData: null,
            ekspedisiData: null,
            plantData: [], // This will store the plant data
            modal: {
                viewPlan: false,
                viewDetailDataPlan: [],
                upload: false,
            },
            user,
            allocationData: [], // Your data here
            expandedRows: [],

            regions: this.$store.getters.getRegion,
            ekspedisi: this.$store.getters.getEkspedisi,
            rangePickr: {
                mode: "range",
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d M Y",
                altInputClass: "form-control input grey-flatpickr",
            },
            options: {
                region: this.$store.getters.getRegion,
            },
            selected: {
                date: `${startDate} to ${currentDate}`,
            },
            filter: {
                start: startDate,
                end: currentDate,
                region: null,
                ekspedisi: null,
            },
            data: null,
        };
    },
    components: {
        Multiselect,
        DonutChart,
        EkspedisiChart,
        ViewDetailModal,
        AlokasiUpload,
    },
    mounted() {
        this.getData();
        this.fetchPlantData();
    },
    watch: {
        filter: {
            deep: true,
            handler: "getData",
        },
        "selected.date"() {
            let split = this.selected.date.split(" to ");
            this.filter.start = split[0];
            this.filter.end = split.length > 1 ? split[1] : split[0];
        },
        "selected.dateButtonsIndex"() {
            // this.filter.filter = this.selected.dateButtonsIndex != -1 ? this.options.dateButtons[this.selected.dateButtonsIndex].filter : 'CUSTOM'
        },
    },
    computed: {
        updatedDetails() {
            // Create a map of plant_id to plant_name for faster lookup
            const plantIdToNameMap = {};
            this.plantData.forEach((plant) => {
                plantIdToNameMap[plant.id] = plant.plant_name;
            });

            // Map plant_id to plant_name in your item.details array
            return this.item.details.map((detail) => ({
                ...detail,
                plant_name: plantIdToNameMap[detail.plant_id] || "Unknown", // Use 'Unknown' if plant_id doesn't match
            }));
        },
    },
    methods: {
        async fetchPlantData() {
            try {
                const response = await axios.get("/api/master/plant");
                this.plantData = response.data; // Store the fetched plant data
            } catch (error) {
                console.error("Error fetching plant data:", error);
            }
        },
        getTotalQty(details) {
            let totalQty = 0;
            details.forEach((detail) => {
                totalQty += Number(detail.qty);
            });

            return totalQty;
        },
        toggleRow(index) {
            this.$set(this.expandedRows, index, !this.expandedRows[index]);
        },
        editData() {

            // Navigate to edit-alokasi page
            this.$router.push({ name: "EditAlokasi" });
        },
        getData() {

            if (this.filter.region === 'All' || this.filter.ekspedisi === 999) {
                this.filter = {...this.filter, region: null, ekspedisi: null};
            }
            // Fetch data using Axios
            axios
                .get(
                    `/api/alokasi-muat/list?${qs.stringify(this.filter, {
                        skipNulls: true,
                        arrayFormat: "comma",
                    })}`
                )
                .then((response) => {
                    this.allocationData = response.data.data;
                })
                .catch((error) => {
                    console.error(error);
                });

            // Total Unit by Plant Chart
            // this.unitData = []
            this.$http
                .get(
                    `/api/plan-alokasi/report-by-plant?${qs.stringify(
                        this.filter,
                        {
                            skipNulls: true,
                            arrayFormat: "comma",
                        }
                    )}`
                )
                .then((resp) => {
                    this.unitData = resp.data.data;
                })
                .catch((err) => console.log(err));

            // Total Unit by Ekspedisi Chart
            // this.ekspedisiData = []
            this.$http
                .get(
                    `/api/plan-alokasi/report-by-ekspedisi?${qs.stringify(
                        this.filter,
                        {
                            skipNulls: true,
                            arrayFormat: "comma",
                        }
                    )}`
                )
                .then((resp) => {
                    this.ekspedisiData = resp.data.data;
                })
                .catch((err) => console.log(err));
        },
        getPlantNames(details) {
            const newArr = [];
            details.forEach((detail) => {
                newArr.push(detail.plant_name);
            });
            const finalArr = [...new Set(newArr)];
            if (finalArr.length > 5) {
                return `${finalArr.slice(0, 5).join(", ")}, ...`;
            }

            return finalArr.join(", ");
        },
        confirmDelete(date) {
            // Show a confirmation dialog with SweetAlert2
            Swal.fire({
                title: "Are you sure?",
                text: "You will not be able to recover this entry!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No, cancel",
            }).then((result) => {
                if (result.isConfirmed) {
                    // If confirmed, send a DELETE request to delete the entry
                    axios
                        .delete("/api/alokasi-muat/delete", {
                            data: {
                                date: date,
                            },
                        })
                        .then((response) => {
                            // Handle successful deletion
                            console.log("Entry deleted:", response);
                            // You can update the table data here or reload the data if needed
                            this.getData();
                            Swal.fire(
                                "Deleted!",
                                "Alokasi muat berhasil dihapus.",
                                "success"
                            );
                        })
                        .catch((error) => {
                            console.error("Error deleting entry:", error);
                            Swal.fire(
                                "Error!",
                                "Alokasi muat tidak ditemukan.",
                                "error"
                            );
                        });
                }
            });
        },
        getDetail(i) {
            this.modal.viewPlan = true;
            const dataViewDetailAlocationPlan = {
                tanggal: this.allocationData[i].alokasi_date,
                details: this.allocationData[i].details,
                ekspedisi: this.allocationData[i].ekspedisi,
            };
            this.modal.viewDetailDataPlan = dataViewDetailAlocationPlan;
        },
    },
};
</script>

<style scoped>
.innerBox {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 10px 20px;
}

.align-middle {
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 27px;
    font-weight: bold;
    margin: 0;
}

.tms-button-circular {
    width: 40px; /* Set the width and height to the same value for a perfect circle */
    height: 40px;
    border-radius: 50%; /* Makes the button circular */
    background-color: #d8e4ff; /* Sets the background color */
    padding: 10px 20px; /* Adjust padding to fit your content */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    outline: none;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Adjust shadow values as needed */
}

/* tms-table start */
.tms-table {
    width: 100%;
    border-collapse: collapse;
}

.tms-table th,
.tms-table td {
    padding: 8px;
    text-align: left;
    vertical-align: middle;
}

/* Styling for table headers */
.tms-table th {
    color: #bcbcbc;
    font-weight: normal;
    border-bottom: 0px solid #e4e7ea;
}

/* Styling for table data cells */
.tms-table td {
    font-weight: normal;
}

/* Remove top border from first row */
.tms-table tr:first-child td {
    border-top: none;
}
/* tms-table end */
</style>
